import { render, staticRenderFns } from "./AddLuckyNumberDialog.vue?vue&type=template&id=b1999dc6&scoped=true"
import script from "./AddLuckyNumberDialog.vue?vue&type=script&lang=js"
export * from "./AddLuckyNumberDialog.vue?vue&type=script&lang=js"
import style0 from "./AddLuckyNumberDialog.vue?vue&type=style&index=0&id=b1999dc6&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b1999dc6",
  null
  
)

export default component.exports